<template lang="html">
  <section>
    <div class="botones-pagina">
      <router-link tag="button" :to="{ name: 'notas' }" class="boton boton--volver"/>
    </div>
    <nota/>
  </section>
</template>

<script>
import nota from "./Nota.vue";

export default {
  components: {
    nota,
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/notas/FormNota.vue